import type { FC } from 'react';
import { Box, CircularProgress, Stack } from '@mui/material';

export const PageLoading: FC = () => {
  return (
    <Box
      sx={{
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        backdropFilter: 'blur(5px)',
        zIndex: 1101,
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{
          width: '100vw',
          height: '100vh',
        }}
      >
        <CircularProgress size={48} thickness={4} />
      </Stack>
    </Box>
  );
};
